import { FC } from 'react';

import type { SanityFaqBlock } from '@lib/sanity/types';

type FaqProps = {
  faq: SanityFaqBlock;
};

const Faq: FC<FaqProps> = ({ faq }) => {
  const { heading, items } = faq;

  if (!items || items.length === 0) return null;

  return (
    <section className="border-t border-landing-hairline bg-white px-6 py-14">
      <div className="mx-auto w-full max-w-md md:max-w-2xl">
        {heading && (
          <h2 className="cms-heading mb-6 text-landing-ink">{heading}</h2>
        )}

        <div>
          {items.map((item) => (
            <details
              key={item._key}
              className="group border-b border-landing-hairline py-4"
            >
              <summary className="flex cursor-pointer list-none items-center justify-between gap-4 text-sm font-bold text-landing-ink [&::-webkit-details-marker]:hidden">
                {item.question}
                <span className="shrink-0 text-lg font-normal text-landing-muted transition-transform group-open:rotate-45 motion-reduce:transition-none">
                  +
                </span>
              </summary>
              <p className="mt-3 text-sm leading-relaxed text-landing-slate">
                {item.answer}
              </p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
